import React, { FC, useState } from 'react'
import clsx from 'clsx'
import { useMutation, useQueryClient } from 'react-query'
import axios from 'axios'
import { successToast, errorToast } from '../../../../../../../_metronic/helpers/components/Toaster'
import { QUERIES } from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import UploadImage from '../../../../../../../_metronic/helpers/components/ImageUpload'

type Props = {
    id: any
    close: () => void
}

const ViewApproveModal: FC<Props> = ({ id, close }) => {
    const { query } = useQueryResponse()
    const queryClient = useQueryClient()
    const [loading, setLoading] = useState(false)
    console.log("iddd", id)
    const validationSchema = Yup.object().shape({
        mode: Yup.string().required('Mode is required'),
        transporter: Yup.string().required('Transporter is required'),
        destination: Yup.string().required('Destination is required'),
        distance: Yup.number().required('Distance is required').typeError('Distance must be a number'),
        cost: Yup.number().required('Cost is required').typeError('Cost must be a number'),
        remarks: Yup.string().required('Remarks are required'),
        // poCopy: Yup.string().required('PO Copy is required'),
    })

    const formik = useFormik({
        initialValues: {
            mode: id?.shippingInfo?.mode || "",
            transporter: id?.shippingInfo?.transporterName || "",
            destination: id?.shippingInfo?.destination || "",
            distance: id?.shippingInfo?.distance || "0",
            cost: id?.shippingInfo?.transportCost || "0",
            remarks: "",
            poCopy: "",
        },
        validationSchema,
        onSubmit: handleApprove,
    })

    async function handleApprove() {
        try {
            setLoading(true)

            // Get auth token and user info from localStorage
            const authData = localStorage.getItem('kt-auth-react-v')
            const token = authData ? JSON.parse(authData).data.token : null
            const userId = authData ? JSON.parse(authData).data.userId : 'F2001'
            const userName = authData ? JSON.parse(authData).data.userName : 'FinanceUser'

            console.log('Using userId:', userId)
            console.log('Using userName:', userName)

            // Make API call to approve transport update
            const response = await axios.post(
                `https://pfc-backend-api.asmglobal.co.in/v1/api/transactions/${id.id}/transport-approve`,
                {
                    mode: formik.values.mode,
                    transporter: formik.values.transporter,
                    destination: formik.values.destination,
                    address: id?.shippingInfo?.address || id?.sellerInfo?.address || "",
                    shippedBy: id?.shippingInfo?.shippedBy || "SELLER",
                    distance: formik.values.distance,
                    transportCost: Number(formik.values.cost),
                    remarks: formik.values.remarks,
                    poCopy: formik.values.poCopy
                },
                {
                    params: {
                        status: "TRANSPORT_APPROVED",
                        userId: userId,
                        userName: userName,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            )

            console.log('Approval Response:', response.data)
            successToast('Order approved successfully!')
            queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
            close()
        } catch (error) {
            console.error('Error approving order:', error)
            if (error instanceof Error) {
                errorToast(error.message)
            } else {
                errorToast('Error approving order')
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 2000,
            }}
            onClick={close}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    padding: '30px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    maxWidth: '500px',
                    width: '90%',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <h3 style={{ marginBottom: '20px', fontWeight: 600, fontSize: "17.55px" }}>Approve</h3>

                <form onSubmit={formik.handleSubmit} noValidate>



                    {/* Shipping Mode Field */}
                    <div className='fv-row mb-7'>
                        <label className='required fw-bold fs-6 mb-2'>Shipping Mode</label>
                        <select
                            style={{ background: 'white', border: '1px solid #cccccc' }}
                            {...formik.getFieldProps('mode')}
                            className={clsx('form-control form-control-solid', {
                                'is-invalid': formik.touched.mode && formik.errors.mode,
                            })}
                        >
                            <option value=''>Select Shipping Mode</option>
                            <option value='ROAD'>Road</option>
                            <option value='RAIL'>Rail</option>
                            <option value='SHIP'>Ship</option>
                        </select>
                        {formik.touched.mode && formik.errors.mode && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.mode as string}</span>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Transporter Field */}
                    <div className='fv-row mb-7'>
                        <label className='required fw-bold fs-6 mb-2'>Transporter</label>
                        <input
                            type='text'
                            {...formik.getFieldProps('transporter')}
                            placeholder='Enter transporter name'
                            className='form-control form-control-solid mb-3 mb-lg-0'
                            autoComplete='off'
                            disabled={loading}
                            style={{ background: 'white', border: '1px solid #cccccc' }}
                        />
                        {formik.touched.transporter && formik.errors.transporter && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.transporter as string}</span>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Destination Field */}
                    <div className='fv-row mb-7'>
                        <label className='required fw-bold fs-6 mb-2'>Destination</label>
                        <input
                            type='text'
                            {...formik.getFieldProps('destination')}
                            placeholder='Enter destination'
                            className='form-control form-control-solid mb-3 mb-lg-0'
                            autoComplete='off'
                            disabled={loading}
                            style={{ background: 'white', border: '1px solid #cccccc' }}
                        />
                        {formik.touched.destination && formik.errors.destination && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.destination as string}</span>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className='row'>
                        <div className='col-6'>
                            {/* Distance Field */}
                            <div className='fv-row mb-7'>
                                <label className='required fw-bold fs-6 mb-2'>Distance (km)</label>
                                <input
                                    type='text'
                                    {...formik.getFieldProps('distance')}
                                    placeholder='Enter distance'
                                    className='form-control form-control-solid mb-3 mb-lg-0'
                                    autoComplete='off'
                                    disabled={loading}
                                    style={{ background: 'white', border: '1px solid #cccccc' }}
                                />
                                {formik.touched.distance && formik.errors.distance && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span role='alert'>{formik.errors.distance as string}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='col-6'>
                            {/* Cost Field */}
                            <div className='fv-row mb-7'>
                                <label className='required fw-bold fs-6 mb-2'>Cost (INR)</label>
                                <input
                                    type='text'
                                    {...formik.getFieldProps('cost')}
                                    placeholder='Enter cost'
                                    className='form-control form-control-solid mb-3 mb-lg-0'
                                    autoComplete='off'
                                    disabled={loading}
                                    style={{ background: 'white', border: '1px solid #cccccc' }}
                                />
                                {formik.touched.cost && formik.errors.cost && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span role='alert'>{formik.errors.cost as string}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className='fv-row mb-7'>
                        <label className='required fw-bold fs-6 mb-2'>Remarks</label>
                        <textarea
                            {...formik.getFieldProps('remarks')}
                            placeholder='Enter approval remarks...'
                            className='remarks-textarea'
                            style={{
                                width: '100%',
                                padding: '10px',
                                border: formik.touched.remarks && formik.errors.remarks ? '1px solid #f8285a' : '1px solid #ddd',
                                borderRadius: '4px',
                                fontFamily: 'inherit',
                                minHeight: '50px',
                                resize: 'vertical',
                                color: "#000"
                            }}
                            disabled={loading}
                        />
                        <style>{`
                            .remarks-textarea::placeholder,
                            input::placeholder {
                                color: black !important;
                                opacity: 1;
                            }
                        `}</style>
                        {formik.touched.remarks && formik.errors.remarks && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block' style={{ color: '#f8285a' }}>
                                    {formik.errors.remarks}
                                </div>
                            </div>
                        )}
                    </div>

                    <UploadImage
                        label='Upload PO Copy (Optional)'
                        name='poCopy'
                        formik={formik}
                        filetype='image/*,.pdf'
                    />
                    {/* {formik.touched.poCopy && formik.errors.poCopy && (
                        <div className='fv-plugins-message-container'>
                            <div className='fv-help-block' style={{ color: '#f8285a' }}>
                                {formik.errors.poCopy}
                            </div>
                        </div>
                    )} */}

                    {/* Action Buttons */}
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <button
                            type='button'
                            onClick={close}
                            className='btn btn-light'
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type='submit'
                            className='btn btn-success'
                            disabled={loading}
                        >
                            {loading ? 'Approving...' : 'Approve'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ViewApproveModal